<template>
  <div class="flex flex-wrap -mx-1">
    <div
      v-for="(image, index) in images"
      :key="image.src"
      class="w-full xs:w-1/2 sm:w-1/3 px-1 py-1"
    >
      <a href="#" @click.prevent="openLightbox(index)" class="block relative pb-full">
        <img
          :src="resolveUrl(image.src)"
          :alt="image.alt"
          class="absolute object-cover w-full h-full"
        />
      </a>
    </div>
  </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import 'photoswipe/dist/photoswipe.css';

export default {
  name: 'PhotoGallery',
  props: { images: Array },
  data() {
    return { lightbox: null };
  },
  async mounted() {
    const dataSource = await Promise.all(
      this.images.map(image => new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve({
          src: img.src,
          alt: image.alt,
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
        img.src = this.resolveUrl(image.src);
      }))
    );
    this.lightbox = new PhotoSwipeLightbox({
      dataSource,
      pswpModule: () => import('photoswipe/dist/photoswipe.esm.js'),
    });
    this.lightbox.init();
  },
  beforeDestroy() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  },
  methods: {
    resolveUrl(src) {
      return require('../assets/' + src);
    },
    openLightbox(index) {
      this.lightbox.loadAndOpen(index);
    },
  },
};
</script>
